const I18N_WHITELIST = [
    'bg',
    'cs',
    'da',
    'de',
    'en',
    'es',
    'fr',
    'fr-CA',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'no',
    'pl',
    'pt',
    'pt-BR',
    'ru',
    'sv',
    'tr',
    'zh-CN',
];

module.exports = {
    I18N_WHITELIST,
};
